import { Moment } from "moment";
import { BookingWithData } from "PFCore/hooks/queries/profile";

import { BulkUpdateDetails, Duration } from "../booking_edit_mode_store.types";

export const bulkDraftMove = (
  booking: BookingWithData,
  selectedDate: string,
  bookingsRangeMinDate: string | null,
  utc: (date: string) => Moment
): BookingWithData => {
  if (!bookingsRangeMinDate) {
    return booking;
  }
  const offsetInDays = utc(selectedDate).diff(utc(bookingsRangeMinDate).startOf("day"), "days");

  return {
    ...booking,
    start_date: utc(booking.start_date).add(offsetInDays, "days").toISOString(),
    end_date: utc(booking.end_date).add(offsetInDays, "days").toISOString()
  };
};

export const bulkDraftUpdateStartDate = (
  booking: BookingWithData,
  selectedDate: string,
  utc: (date: string) => Moment
): BookingWithData => {
  const isSelectedDateAfterEndDate = utc(booking.end_date).isBefore(utc(selectedDate));

  if (isSelectedDateAfterEndDate) {
    return booking;
  }

  return {
    ...booking,
    start_date: selectedDate
  };
};

export const bulkDraftUpdateEndDate = (
  booking: BookingWithData,
  selectedDate: string,
  utc: (date: string) => Moment
): BookingWithData => {
  const isSelectedDateBeforeStartDate = utc(booking.start_date).isAfter(utc(selectedDate).endOf("day"));

  if (isSelectedDateBeforeStartDate) {
    return booking;
  }

  return {
    ...booking,
    end_date: selectedDate
  };
};

export const bulkDraftUpdateDetails = (
  booking: BookingWithData,
  details: BulkUpdateDetails
): BookingWithData => {
  const { bookingCategoryId, title, description } = details;

  return {
    ...booking,
    booking_category_id: bookingCategoryId.enabled
      ? bookingCategoryId.value?.category?.id
      : booking.booking_category_id,
    title: title.enabled ? title.value : booking.title,
    description: description.enabled ? description.value : booking.description
  };
};

export const bulkDraftUpdateDuration = (booking: BookingWithData, duration: Duration): BookingWithData => {
  const { durationType, durationValue } = duration;

  return {
    ...booking,
    requirement_type: durationType,
    requirement_value: durationValue
  };
};
